{
    "name": "create-express-modular",
    "version": "3.3.2",
    "description": "Scaffold a modular, domain-driven Express + TypeScript backend. Choose your database (Mongoose, Prisma, or Drizzle) and validator (Zod or Joi). Optionally add JWT auth and Docker setup.",
    "bin": {
        "create-express-modular": "./dist/bin/cli.js",
        "cem": "./dist/bin/cli.js"
    },
    "files": [
        "dist",
        "template",
        "README.md",
        "DOCS.md",
        "package.json",
        "LICENSE",
        "CHANGELOG.md"
    ],
    "engines": {
        "node": ">=18.0.0",
        "npm": ">=9.0.0"
    },
    "scripts": {
        "build": "tsup",
        "prepublishOnly": "npm run build",
        "test": "echo \"Error: no test specified\" && exit 1"
    },
    "keywords": [
        "express",
        "typescript",
        "modular",
        "scaffold",
        "cli",
        "mongoose",
        "prisma",
        "drizzle",
        "postgresql",
        "zod",
        "joi",
        "jwt",
        "auth",
        "docker",
        "domain-driven",
        "backend",
        "boilerplate"
    ],
    "author": "levi9111",
    "license": "MIT",
    "repository": {
        "type": "git",
        "url": "git+https://github.com/Levi9111/npm-create-express-modular.git"
    },
    "bugs": {
        "url": "https://github.com/Levi9111/npm-create-express-modular/issues"
    },
    "homepage": "https://create-express-modular.lovable.app/docs",
    "dependencies": {
        "http-status-codes": "^2.3.0",
        "inquirer": "^8.2.7"
    },
    "devDependencies": {
        "@types/inquirer": "^8.2.13",
        "@types/node": "^26.1.1",
        "tsup": "^8.5.1",
        "typescript": "^7.0.2"
    }
}
